import React, { useEffect, useState } from "react";
import DefaultGrid from "../../Components/Default/DefaultGrid";
import { FrontEndRoutes } from "../../config/front-end-routes";
import { useNavigate } from "react-router-dom";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { toast } from "react-toastify";
import { useFilters } from "../../Components/Filters/UseFilter";

const PageProdutos: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [products, setProducts] = useState<any[]>([]);
    const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
    const { filters, handleFilterChange } = useFilters([]);

    const columns = [
        {
            key: "modelo",
            label: "Código",
            filterType: "text",
        },
        {
            key: "descricao",
            label: "Nome do Produto",
            filterType: "text",
        },
        {
            key: "grupo",
            label: "Categoria",
            filterType: "text",
        },
        {
            key: "status",
            label: "Status",
            filterType: "select",
            options: [
                { value: "1", description: "Ativo" },
                { value: "0", description: "Inativo" },
            ],
            render: (item: any) => (
                <select
                    className="form-select"
                    value={item.status}
                    disabled
                    onChange={(e) => {
                        const newStatus = parseInt(e.target.value, 10);
                        api
                            .put(BackEndRoutes.routes.PRODUTOS.EDIT.replace(":id", item.id), { status: newStatus })
                            .then(() => {
                                setProducts((prev) =>
                                    prev.map((term) =>
                                        term.id === item.id ? { ...term, status: newStatus } : term
                                    )
                                );
                                toast.success("Status atualizado com sucesso!");
                            })
                            .catch(() => {
                                toast.error("Erro ao atualizar status.");
                            });
                    }}
                >
                    <option value={1}>Ativo</option>
                    <option value={0}>Inativo</option>
                </select>
            ),
        },
    ];

    const handleProducts = async () => {
        setLoading(true);
        try {
            const response = await api.get(BackEndRoutes.routes.PRODUTOS.LIST);
            console.log(response.data, "produtos aqui");
            if (response.data) {
                setProducts(response.data);
                setFilteredProducts(response.data);
            }
        } catch (error) {
            console.error("Erro ao buscar produtos:", error);
            toast.error("Erro ao buscar produtos.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleProducts();
    }, []);

    const handleCreateProduct = () => {
        navigate(FrontEndRoutes.PRODUTOS.CREATE);
    };

    const handleEditProduct = (product: any) => {
        navigate(FrontEndRoutes.PRODUTOS.EDIT.replace(":id", product.id_produto
        ));
    };

    return (
        <div>
            <DefaultGrid
                title="Lista de Produtos"
                onAdd={handleCreateProduct} // Redireciona para criação
                columns={columns}
                filters={filters}
                handleFilterChange={handleFilterChange}
                items={filteredProducts}
                itemsPerPage={10}
                loading={loading}
                onReload={handleProducts}
                onEdit={handleEditProduct} // Redireciona para edição
                onDelete={(item) => console.log("Delete:", item)}
            />
        </div>
    );
};

export default PageProdutos;
